import React from 'react';

interface StarRatingProps {
  value: number;
  max?: number;
  size?: number;
}

export default function StarRating({ value, max = 5, size = 14 }: StarRatingProps) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: max }).map((_, i) => {
        const filled = i < Math.floor(value);
        const partial = !filled && i < value;
        return (
          <svg
            key={`star-${i}`}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={filled ? '#D4A843' : partial ? 'url(#half)' : 'none'}
            stroke={filled || partial ? '#D4A843' : '#D1D5DB'}
            strokeWidth="1.5"
          >
            <defs>
              <linearGradient id="half" x1="0" x2="1" y1="0" y2="0">
                <stop offset="50%" stopColor="#D4A843" />
                <stop offset="50%" stopColor="transparent" />
              </linearGradient>
            </defs>
            <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
          </svg>
        );
      })}
    </div>
  );
}